import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import pt from "./locales/pt.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", dir: "ltr", flag: "EN" },
  { code: "es", label: "Español", dir: "ltr", flag: "ES" },
  { code: "ar", label: "العربية", dir: "rtl", flag: "AR" },
  { code: "pt", label: "Português", dir: "ltr", flag: "PT" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      ar: { translation: ar },
      pt: { translation: pt },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "bid_lang",
    },
  });

export const applyLangDir = (lng) => {
  const meta = SUPPORTED_LANGUAGES.find(l => l.code === lng);
  if (meta) {
    document.documentElement.dir = meta.dir;
    document.documentElement.lang = meta.code;
  }
};

i18n.on("languageChanged", (lng) => applyLangDir(lng));
applyLangDir(i18n.language);

export default i18n;
